import getDashboardReducers from './dashboardReducers/combinedReducers';
import getStandaloneReducers from './standaloneReducers/combinedReducers';

export default function getAllReducers(appName){
  switch (appName) {
    case "Dashboard":
        return getDashboardReducers();
      break;
    case "Standalone" :
        return getStandaloneReducers();
      break;
    default:
      return;
  }
}
